// Period League — working title, will change. Every component displaying the competition's name
// must import and use this constant rather than hardcoding the string.
export const SSG_COMPETITION_NAME = 'Period League';

// base_points is strictly 0 | 1 | 3 (never a free number) — one shared source for the
// label/color pair everywhere it's rendered (session editor, leaderboard, badges, TV).
export const SSG_RESULTS = [
  { value: 0, label: 'Loss', short: 'L', color: '#64748b' },
  { value: 1, label: 'Draw', short: 'D', color: '#f59e0b' },
  { value: 3, label: 'Win',  short: 'W', color: '#10b981' },
];

export function ssgResultMeta(basePoints) {
  return SSG_RESULTS.find(r => r.value === basePoints) || null;
}

// Every badge key/label/unlock-criterion the backend can award (see ssgCompetition.js's
// getBadgesForPeriod) — the one place a player-facing "earned in colour, unearned greyed with
// the unlock criterion as caption" view needs, since the API only ever returns badges a player
// has actually earned, never the full catalogue.
export const SSG_BADGES = [
  { key: 'unbeaten', label: 'Unbeaten', emoji: '🛡️', criterion: '3+ consecutive played sessions without a loss' },
  { key: 'on_fire', label: 'On Fire', emoji: '🔥', criterion: '3+ consecutive wins' },
  { key: 'bonus_hunter', label: 'Bonus Hunter', emoji: '💰', criterion: 'Highest bonus points total in the period' },
  { key: 'mvp', label: 'MVP', emoji: '⭐', criterion: 'Named MVP at least once' },
  { key: 'climber', label: 'Climber', emoji: '📈', criterion: 'Gained 3+ ranks since the last session' },
  { key: 'flawless', label: 'Flawless', emoji: '💎', criterion: 'No losses all period (min. 3 played)' },
  { key: 'period_champion', label: 'Period Champion', emoji: '🏆', criterion: 'Won the period' },
];
